/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */

import { types } from "mobx-state-tree"
import { QueryBuilder } from "mst-gql"
import { ModelBase } from "./ModelBase"
import { RootStoreType } from "./index"


/**
 * DeleteCustomMappingsDtoBase
 * auto generated base class for the model DeleteCustomMappingsDtoModel.
 */
export const DeleteCustomMappingsDtoModelBase = ModelBase
  .named('DeleteCustomMappingsDto')
  .props({
    __typename: types.optional(types.literal("DeleteCustomMappingsDto"), "DeleteCustomMappingsDto"),
    wasDeleted: types.union(types.undefined, types.boolean),
  })
  .views(self => ({
    get store() {
      return self.__getStore<RootStoreType>()
    }
  }))

export class DeleteCustomMappingsDtoModelSelector extends QueryBuilder {
  get wasDeleted() { return this.__attr(`wasDeleted`) }
}
export function selectFromDeleteCustomMappingsDto() {
  return new DeleteCustomMappingsDtoModelSelector()
}

export const deleteCustomMappingsDtoModelPrimitives = selectFromDeleteCustomMappingsDto().wasDeleted
